import { jsx as s } from "@emotion/react/jsx-runtime";
import a, { buttonClasses as u } from "@mui/material/Button";
import { forwardRef as n } from "react";
import r, { iconButtonClasses as i } from "@mui/material/IconButton";
import e, { loadingButtonClasses as l } from "@mui/lab/LoadingButton";
const g = u, B = n((t, o) => /* @__PURE__ */ s(a, { ...t, ref: o }));
B.displayName = "Button";
const b = i, m = n((t, o) => /* @__PURE__ */ s(r, { ...t, ref: o }));
m.displayName = "IconButton";
const L = l, c = n((t, o) => /* @__PURE__ */ s(e, { ...t, ref: o }));
c.displayName = "LoadingButton";
export {
  B,
  m as I,
  c as L,
  g as b,
  b as i,
  L as l
};
